module.exports = __webpack_public_path__ + "img/Safe_perspective_matte 1.f26bed0c.png";